import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { useQuery } from "@tanstack/react-query";
import { useAuth, User } from "../../auth/useAuth";
import { odataFetch } from "../../lib/odata-fetch";
import { UserHAEquipmentPreferences } from "../../odata/appu4dm/AppU4DMModel";
import {
  qUserHAEquipmentPreferences,
  QUserHAEquipmentPreferences,
} from "../../odata/appu4dm/QAppU4DM";
import { machineKeys } from "./machine-keys";

export function useMachine() {
  const { user } = useAuth();

  const { data, ...query } = useQuery({
    queryKey: machineKeys.get(user?.unique_name),
    queryFn: ({ meta }) => fetchMachine(user!, meta!.token!),
    enabled: ({ meta }) => !!(user && meta?.token),
  });

  return {
    machine: data?.value[0],
    noActiveMachine: !query.isFetching && !data?.value.length,
    ...query,
  };
}

type Machine = Pick<UserHAEquipmentPreferences, "EquipmentNId">;

async function fetchMachine(user: User, token: string) {
  const builder = createQueryBuilderV4(
    "UserHAEquipmentPreferences",
    new QUserHAEquipmentPreferences()
  )
    .select("EquipmentNId")
    .filter(
      qUserHAEquipmentPreferences.User.toLower().equals(
        user.unique_name.toLowerCase()
      )
    );

  return odataFetch<Machine>({ builder, token });
}
